export const BILLING_REFERENCE_TOOLTIP =
  "This value will appear in the header of related Invoices/RCTI's and line items on the Invoice may be grouped by this value.";

export const ConsignmentGroupByOptions = {
  VENDOR: "Vendor",
  VENDOR_NUMBER: "Vendor No",
  RECEIVING_PEN: "Receiving Pen",
};

export const ConsignmentType = {
  PRIMARY: "Primary",
  VENDOR_SPLIT: "Vendor Split",
};

// A marker for when we don't know the consignment id
export const UNKNOWN_CONSIGNMENT_ID = "UNKNOWN_CONSIGNMENT_ID";
